import styled from 'styled-components';

export const OrderPageContainer = styled.div`
    padding: 1rem 2rem;
    position: relative;
    overflow: visible;
    z-index: 1;
    min-height: 100vh;

    /* Estilos para el contenedor del Typeform */
    [data-tf-live] {
        width: 100%;
        min-height: calc(100vh - 150px);
    }

    @media (max-width: 768px) {
        padding: 1rem;

        [data-tf-live] {
            min-height: calc(100vh - 120px);
        }
    }

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('/img/LogoDuoaColor.png');
        background-size: 400px;
        background-repeat: repeat;
        background-position: center;
        opacity: 0.05;
        z-index: -1;
    }
`;